var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eg-search-select',{attrs:{"items":_vm.items,"value":_vm.value,"required":true,"title-key":"name","filter-item-function":_vm.filterItemFunction},on:{"update:search":_vm.locationAutocomplete,"input":_vm.selectLocation}})
}
var staticRenderFns = []

export { render, staticRenderFns }